<template>
  <router-link :to="{ name: 'Product', params: { id: product.id } }">
    <div class="ui-product">
      <div class="ui-product-img">
        <img :src="product.images[0].image_path" />
        <div class="ui-product-hover">
          <p>{{ product.short_description }}</p>
        </div>
      </div>
      <div class="ui-product-info">
        <p>{{ product.title }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="sass">
.ui-product
  @apply w-full rounded-t-lg mb-4
  &:hover
    .ui-product-hover
      @apply opacity-100
    .ui-product-info
      @apply opacity-100 h-24
  &-img
    @apply z-0 relative
    img
      @apply rounded-t-lg
  &-hover
    background: linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5))
    background-blend-mode: overlay
    transition: opacity 0.3s ease-in-out
    @apply absolute top-0 left-0 w-full h-full z-10 flex justify-center items-center opacity-0
  &-info
    background: $accent-color
    transition: all 0.3s ease-in-out
    @apply w-full h-0 flex flex-col justify-center items-center opacity-0 rounded-b-lg
</style>
